import RobotSvg from '@/assets/RobotSvg.svg';
import DialogMobile from '@/components/dialog/DialogMobile.tsx';
import { DomPurifyConfig } from '@/config/DomPurify.config.ts';
import { generateNonCachableImageSrc } from '@/utils/generateNonCachableImageSrc.util.ts';
import DOMPurify from 'dompurify';
import React from 'react';

export interface QuizFinishedMessageProps {
  additionalMessage?: string;
  message: string;
  subMessage?: string;
}

const QuizFinishedMessageMobile: React.FC<QuizFinishedMessageProps> = ({
  additionalMessage,
  message,
  subMessage,
}) => {
  return (
    <div className="flex flex-col justify-content-between min-h-[400px]">
      <DialogMobile
        content={
          <>
            <p
              className="body"
              dangerouslySetInnerHTML={{
                __html: subMessage ? DOMPurify.sanitize(subMessage, DomPurifyConfig) : '',
              }}
            />
            {additionalMessage && <p className="body mt-3">{additionalMessage}</p>}
          </>
        }
        image={
          <img
            alt="robot"
            className="align-self-end object-cover w-1/2"
            src={generateNonCachableImageSrc(RobotSvg)}
          />
        }
        message={message}
      />
    </div>
  );
};

export default QuizFinishedMessageMobile;
